import React from 'react';
import axios from 'axios';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';
import stylesSearch from '../styles/Search.module.css';

const AddNewCase = ({ closeModal, onAddNewCaseSuccess }) => {

  const [status, setStatus] = React.useState('');
  const [labels, setLabels] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [phases, setPhases] = React.useState([]);
  const [selectedLabelId, setSelectedLabelId] = React.useState('');
  const [selectedCategoryId, setSelectedCategoryId] = React.useState('');
  const [selectedPhaseId, setSelectedPhaseId] = React.useState('');

  const [number, setNumber] = React.useState('');
  const [internalNumber, setInternalNumber] = React.useState('');
  const [toCaseNumber, setToCaseNumber] = React.useState('');
  const [toCaseId, setToCaseId] = React.useState('');
  const [applicant, setApplicant] = React.useState('');
  const [region, setRegion] = React.useState('');
  const [dateStart, setDateStart] = React.useState('');
  const [dateCourt, setDateCourt] = React.useState('');
  const [comments, setComments] = React.useState('');
  const [fileNameFromUser, setFileNameFromUser] = React.useState('');
  const [file, setFile] = React.useState(null);

  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
      document.body.style.overflow = 'hidden';
  
      return () => {
          document.body.style.overflow = '';
      };
  }, []);

  const goBackToLabels = () => {
    setStatus('');
    setSelectedLabelId('');
    setContent(renderLabels(labels));
  };
  const goBackToCategories = () => {
    setStatus('');
    setSelectedCategoryId('');
    setContent(renderCategories(categories));
  };

  const loadingContent = (
    <div className={styles.liningOver} onClick={closeModal}>
      <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <h1>Загрузка</h1>
          </div>
          <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
          </svg>
        </div>
        <div className={styles.main}>
          <Loading />
        </div>
      </div>
    </div>
  );

  const errorContent = (typeE) => (
    <div className={styles.liningOver} onClick={closeModal}>
      <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.headlineWithBackBtn}>
            <div className={styles.backBtnContainer}>
              <svg onClick={goBackToLabels} viewBox="0 0 24 24">
                <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"></path>
              </svg>
            </div>
            <h1>Ошибка</h1>
          </div>
          <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
          </svg>
        </div>
        <div className={styles.main}>
          <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />Не удалось загрузить {typeE}. Обратитесь к администратору сети</a>
        </div>
      </div>
    </div>
  );

  const [content, setContent] = React.useState(loadingContent);

  React.useEffect(() => {
    const fetchLabels = async () => {
      try {
        const response = await axios.get('/api/labels');
        setLabels(response.data);
        setContent(renderLabels(response.data));
      } catch (error) {
        console.error("Ошибка при загрузке типов:", error);
        setContent(errorContent('типы'));
      }
    };
    fetchLabels();
  }, []);

  const [typeForm, setTypeForm] = React.useState('');
  const renderLabels = (labels) => (
    <div className={styles.liningOver} onClick={closeModal}>
      <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h1>Выберите тип вх. корреспонденции</h1>
          <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
          </svg>
        </div>
        <div className={styles.main}>
          {labels.map((label) => (
            <div className={styles.radioLabel} onClick={(e) => { setSelectedLabelId(label.id); setTypeForm(label.type_form); setContent(null); }} key={label.id}>
              <label htmlFor={label.id}>{label.name}</label>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="angle-right-b"><path fill="black" d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"></path></svg>
            </div>
          ))}
        </div>
      </form>
    </div>
  );

  React.useEffect(() => {
    const fetchCategories = async () => {
      if (selectedLabelId) {
        try {
          const response = await axios.get(`/api/categories?labelId=${selectedLabelId}`);
          // setCategories(response.data);
          // setContent(renderCategories(response.data));
          setContent(null);
        } catch (error) {
          console.error("Ошибка при загрузке категорий:", error);
          setContent(errorContent('категории дел', error.message));
        }
      }
    };
    fetchCategories();
  }, [selectedLabelId]);

  const renderCategories = (categories) => (
    <div className={styles.liningOver}>
      <form className={styles.lining}>
        <div className={styles.header}>
          <div className={styles.headlineWithBackBtn}>
            <div className={styles.backBtnContainer}>
              <svg onClick={goBackToLabels} viewBox="0 0 24 24">
                <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"></path>
              </svg>
            </div>
            <h1>Выберите категорию</h1>
          </div>
          <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
          </svg>
        </div>
        <div className={styles.main}>
          {categories.map((category) => (
            <div className={styles.radioLabel} key={category.id}>
              <label htmlFor={category.id}>{category.name}</label>
              <input
                type='radio'
                className={styles.radioSelect}
                name='category'
                value={category.id}
                onChange={(e) => { setSelectedCategoryId(e.target.value); setContent(loadingContent); }}
                required
              />
            </div>
          ))}
        </div>
      </form>
    </div>
  );

  React.useEffect(() => {
    const fetchPhases = async () => {
      if (selectedCategoryId) {
        try {
          const response = await axios.get(`/api/phases?categoryId=${selectedCategoryId}`);
          setPhases(response.data);
          if (response.data.length > 0) {
            setSelectedPhaseId(response.data[0].id.toString());
          }
          setContent(null);
        } catch (error) {
          console.error("Ошибка при загрузке этапов:", error);
          setContent(errorContent('этапы дел', error.message));
        }
      }
    };
    fetchPhases();
  }, [selectedCategoryId]);

  const [statusFinal, setStatusFinal] = React.useState('');
  const addNewCase = (e) => {
    e.preventDefault();
    setLoading(true);
    let isValid = false;

    if (typeForm === 'case') {
      isValid = internalNumber && applicant && dateStart && dateCourt;
    } else if (typeForm === 'complaint') {
      isValid = internalNumber && toCaseId && dateStart && dateCourt;
    } else if (typeForm === 'other') {
      isValid = internalNumber && dateStart && dateCourt;
    }
    if (file) {
      isValid = fileNameFromUser;
    }

    if (isValid) {
      try {
        const formData = new FormData();
        formData.append('labelId', parseInt(selectedLabelId));
        formData.append('number', number);
        formData.append('internalNumber', internalNumber);
        formData.append('toCaseId', toCaseId);
        formData.append('applicant', applicant);
        formData.append('region', region);
        formData.append('dateStart', dateStart);
        formData.append('dateCourt', dateCourt);
        formData.append('comments', comments);
        formData.append('fileNameFromUser', fileNameFromUser);
        formData.append('file', file);

        axios.post('/api/add-new-case', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        }).then(() => {
          setStatusFinal('Входящая корреспонденция успешно добавлена в систему');
          if (onAddNewCaseSuccess) {
            onAddNewCaseSuccess(); // Уведомляем о добавлении
            setTimeout(() => {
              closeModal();
            }, 1000);
          }
        }).catch(error => {
          setStatus(`Ошибка добавления входящей корреспонденции в систему: ${error.response?.data.message || error.message}`);
        }).finally(() => {
          setLoading(false);
        });
      } catch (error) {
        console.error("Ошибка при добавлении входящей корреспонденции в систему:", error);
        setStatus(`Ошибка добавления входящей корреспонденции в систему: ${error.response?.data.message || error.message}`);
        setLoading(false);
      }
    } else {
      setStatus('Вы не заполнили все обязательные поля');
      setLoading(false);
    }
  }
  // Функция для обработки выбора файла
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Предложения списка карточек для добавления жалобы
  const [casesSugestions, setCasesSugestions] = React.useState([]);
  const [warningSearch, setWarningSearch] = React.useState('');
  const [loadingSearch, setLoadingSearch] = React.useState(false);

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    setLoadingSearch(true);

    if (toCaseNumber !== '') {
      axios.get(`/api/search-cases?searchterm=${toCaseNumber}&type=Входящая корреспонденция`, {
          headers: {
              Authorization: `Bearer ${token}`,
          }
      })
      .then((response) => {
          if (response.data.length === 0) {
              setCasesSugestions([]);
              setWarningSearch('Ничего не найдено.');
          } else {
              setCasesSugestions(response.data);
              setWarningSearch('');
          }
      })
      .catch(error => {
          console.error('Ошибка получения данных '+error);
          setWarningSearch(`Ошибка получения данных:  ${error.response?.data.message || error.message}`);
      })
      .finally(() => {
          setLoadingSearch(false);
      })
    } else {
      setCasesSugestions([]);
      setWarningSearch('');
    }
  }, [toCaseNumber]);

  const caseSelection = (id, number) => {
    setToCaseId(id);
    setToCaseNumber(number);
  };



  return (
    <>
      {content || (
        <div className={styles.liningOver}>
          <form className={styles.lining} onSubmit={addNewCase}>
            <div className={styles.header}>
                <h1>
                  <svg onClick={goBackToLabels} viewBox="0 0 24 24">
                    <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"></path>
                  </svg>
                  Добавьте входящую корреспонденцию в журнал
                </h1>
              <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
              </svg>
            </div>
            <div className={styles.main}>
              {statusFinal ? (
                <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Готово' />{statusFinal}</a>
              ) : 
              (<>
              {typeForm == 'case' &&
              <>
                <div className={styles.requiredFieldsContainer}>
                  <h2>Обязательные поля</h2>

                  <a>Введите номер входящей корреспонденции</a>
                  <input type='text' value={internalNumber} onChange={(e) => setInternalNumber(e.target.value)} maxLength='20' placeholder='Номер входящей корреспонденции' required />

                  <a>Укажите должника</a>
                  <input type='text' value={applicant} onChange={(e) => setApplicant(e.target.value)} maxLength='100' placeholder='Должник' />

                  <a>Введите дату начала отсчета</a>
                  <input type='date' value={dateStart} onChange={(e) => setDateStart(e.target.value)} required />

                  <a>Введите дату судебного заседания о назначении</a>
                  <input type='date' value={dateCourt} onChange={(e) => setDateCourt(e.target.value)} required />
                </div>

                <a>Введите номер дела</a>
                <input type='text' value={number} onChange={(e) => setNumber(e.target.value)} maxLength='20' placeholder='Номер дела' />

                <a>Введите регион</a>
                <input type='text' value={region} onChange={(e) => setRegion(e.target.value)} maxLength='50' placeholder='Регион' />

                <a>Введите комментарий</a>
                <input type='text' value={comments} onChange={(e) => setComments(e.target.value)} maxLength='150' placeholder='Общедоступный комментарий' />

                <a>Прикрепите файл (в формате .pdf)</a>
                <div className={styles.fileAddPanel}>
                  <input type='text' value={fileNameFromUser} onChange={(e) => setFileNameFromUser(e.target.value)} maxLength='100' placeholder='Назовите файл' />
                  <div className='inputFileContainer'>
                    <input type='file' placeholder='Файл' accept=".pdf" onChange={handleFileChange} />
                  </div>
                </div>
                
                {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                {loading ? (<Loading />) : (<button className='button maxWidth black' type='submit'>Добавить</button>)}
              </>
              }
              {typeForm == 'complaint' &&
              <>
                <div className={styles.requiredFieldsContainer}>
                  <h2>Обязательные поля</h2>

                  <a>Введите номер входящей корреспонденции</a>
                  <input type='text' value={internalNumber} onChange={(e) => setInternalNumber(e.target.value)} maxLength='20' placeholder='Номер входящей корреспонденции' required />

                  <a>Введите номер жалобы</a>
                  <input type='text' value={number} onChange={(e) => setNumber(e.target.value)} maxLength='20' placeholder='Номер жалобы' required />

                  <a>Введите ссылку на дело</a>
                  <input type='text' value={toCaseNumber} onChange={(e) => setToCaseNumber(e.target.value)} maxLength='20' placeholder='Номер дела, на которое направлена жалоба' required />
                  {toCaseNumber != '' &&
                    <div className={stylesSearch.liningSearchForm} style={{marginBottom: '15px'}}> 
                      <h2 style={{margin: '0 0 0 10px'}}>Предложения:</h2>
                      <a style={{color: 'rgb(158, 158, 158)', margin: '0px', fontSize: '13px', margin: '0 0 0 10px'}}>Первые 10 совпадений</a>
                      <div className={stylesSearch.header}>
                          <a className={stylesSearch.number}>Номер</a>
                          <a className={stylesSearch.applicant}>Должник</a>
                          <a className={stylesSearch.worker}>Работник</a>
                          <a className={stylesSearch.status}>Статус</a>
                      </div>
                      {warningSearch ? (
                        <>
                          <a className={stylesSearch.warningLine} style={{textAlign: 'center', height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{warningSearch}</a>
                        </>
                        ) : (loadingSearch ? (
                        <>
                          <Loading />
                        </>
                        ) 
                        : 
                        casesSugestions.map((caseItem) => (
                          !caseItem.to_case_number && (
                            <a className={stylesSearch.case} onClick={() => {caseSelection(caseItem.id, caseItem.number)}}>
                              <a className={stylesSearch.number} style={{display: 'flex', alignItems: 'center'}}>{caseItem.id == toCaseId && <span style={{marginRight: '5px'}}><img style={{width: '20px', display: 'flex'}} src='/img/icons/check-circle.svg' alt='+' /></span>} {caseItem.number} {caseItem.internal_number}</a>
                              <a className={stylesSearch.applicant}>{caseItem.applicant || 'Не указан'}</a>
                              <a className={stylesSearch.worker}>
                                  {caseItem.user_id ? (
                                      <>
                                          {caseItem.lastname} {caseItem.firstname} {caseItem.surname} {caseItem.email}
                                      </>
                                      ) : (
                                          'Не определён'
                                      )
                                  }
                              </a>
                              <a className={stylesSearch.status} style={{borderRight: 'none'}}>
                                  {caseItem.status}
                              </a>
                            </a>
                          ) 
                        )
                        )
                      )}
                    </div>
                  }

                  <a>Введите дату начала отсчета</a>
                  <input type='date' value={dateStart} onChange={(e) => setDateStart(e.target.value)} required />
                  
                  <a>Введите дату судебного заседания о назначении</a>
                  <input type='date' value={dateCourt} onChange={(e) => setDateCourt(e.target.value)} required />
                </div>

                <a>Введите должника</a>
                <input type='text' value={applicant} onChange={(e) => setApplicant(e.target.value)} maxLength='100' placeholder='Должник' />

                <a>Введите комментарий</a>
                <input type='text' value={comments} onChange={(e) => setComments(e.target.value)} maxLength='150' placeholder='Общедоступный комментарий' />

                <a>Прикрепите файл (в формате .pdf)</a>
                <div className={styles.fileAddPanel}>
                  <input type='text' value={fileNameFromUser} onChange={(e) => setFileNameFromUser(e.target.value)} maxLength='100' placeholder='Назовите файл' />
                  <div className='inputFileContainer'>
                    <input type='file' placeholder='Файл' accept=".pdf" onChange={handleFileChange} />
                  </div>
                </div>

                {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                {loading ? (<Loading />) : (<button className='button maxWidth black' type='submit'>Добавить</button>)}
              </>
              }
              {typeForm == 'other' &&
              <>
                <div className={styles.requiredFieldsContainer}>
                  <h2>Обязательные поля</h2>

                  <a>Введите номер входящей корреспонденции</a>
                  <input type='text' value={internalNumber} onChange={(e) => setInternalNumber(e.target.value)} maxLength='20' placeholder='Номер входящей корреспонденции' required />

                  <a>Введите дату начала отсчета</a>
                  <input type='date' value={dateStart} onChange={(e) => setDateStart(e.target.value)} required />

                  <a>Введите дату судебного заседания о назначении</a>
                  <input type='date' value={dateCourt} onChange={(e) => setDateCourt(e.target.value)} required />
                </div>

                <a>Введите номер письма</a>
                <input type='text' value={number} onChange={(e) => setNumber(e.target.value)} maxLength='20' placeholder='Номер письма' />

                <a>Введите комментарий</a>
                <input type='text' value={comments} onChange={(e) => setComments(e.target.value)} maxLength='150' placeholder='Общедоступный комментарий' />

                <a>Прикрепите файл (в формате .pdf)</a>
                <div className={styles.fileAddPanel}>
                  <input type='text' value={fileNameFromUser} onChange={(e) => setFileNameFromUser(e.target.value)} maxLength='100' placeholder='Назовите файл' />
                  <div className='inputFileContainer'>
                    <input type='file' placeholder='Файл' accept=".pdf" onChange={handleFileChange} />
                  </div>
                </div>
                
                {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                {loading ? (<Loading />) : (<button className='button maxWidth black' type='submit'>Добавить</button>)}
              </>
              }
              </>
              )
            }
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default AddNewCase;
